import {AGREEMENT_BASIC, AGREEMENT_FULL, INTEREST, PROMISE} from "@/helper/communication/conversation/Collaboration";
import {nl2br} from "@/helper/String";

const PROPERTY_MAPPING = {
	[AGREEMENT_BASIC]: 'agreementBasic',
	[AGREEMENT_FULL]: 'agreementFull',
	[INTEREST]: 'interest',
	[PROMISE]: 'promise',
};

export function get (message)
{
	return nl2br(
		message.collaborationTexts[PROPERTY_MAPPING[message.conversation.collaboration.id]]
	);
}